<div class="card-container">
  <div class="card-format" [style.height.px]="cardSizeScaled">
    <div
      matRipple
      matRippleCentered="true"
      matRippleUnbounded="true"
      class="card-button"
      style="align-items: baseline"
      *ngIf="
        checkLock()
      "
    >
      <mat-icon style="font-size: 90%">
        {{ partnerCard.lock ? "lock_open" : "lock" }}
      </mat-icon>
      <span style="font-size: 75%">Plan Pro</span>
    </div>
    <div class="card-button"
    style="margin-bottom: 1.5em;" *ngIf="
    !checkLock()
  "></div>
    <div
      class="card-content-container"
      fxLayout="column"
      [style.transform]="scaleCard"
      (click)="goToInfo()"
    >
      <div class="card-title" [matTooltip]="partnerCard.name">
        <p>{{ partnerCard.name }}</p>
      </div>

      <div class="card-category">
        <p class="card-text">{{ partnerCard.biography }}</p>
        <div
          class="div"
          *ngIf="!this.partnerCard.name.toLowerCase().includes('kidint')"
        >
          <img
            class="card-img"
            src="{{ partnerCard.url }}"
            width="50%"
          />
        </div>
        <div
          class="div"
          *ngIf="this.partnerCard.name.toLowerCase().includes('kidint')"
        >
          <img
            class="card-img2"
            src="{{ partnerCard.url }}"
            width="{{ partnerCard.size }}"
            
          />
        </div>
      </div>
      <div fxFlex></div>
    </div>
  </div>
</div>
